import { logout } from '../../../membership/dal/data-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../data/store';
import { Fragment } from 'react';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

const Links = () => {

    const dispatch = useAppDispatch();
    const isLoggedIn = useAppSelector(store => store.root.isLoggedIn);
    const columns = useAppSelector(store => store.root.columns);

    const signOut = async () => {
        sendGAEvent('Top Mini Account', 'Sign out');

        dispatch(rootActions.main({
            isLoggedIn: false,
            userName: '',
            isOpened: false,
        }));
        await logout();
        window.location.reload();
    };

    return (
        <section className="grid grid-cols-2 gap-6 text-sm px-2">
            {
                columns.map((columnItems, i) => {

                    const isLastColumn = i === columns.length - 1;

                    return (
                        <div key={ `col-${ i }` }>
                            {
                                columnItems.map((item, j) => {

                                    return (
                                        <Fragment  key={ `${ item.text }-${ item.link }-${ j }` }>
                                            {
                                                item.isTitle &&
                                                <h3 className={ `font-bold mb-1 ${ item.classes ?? '' }` }>{ item.text }</h3>
                                            }

                                            {
                                                !item.isTitle &&
                                                <a
                                                    href={ item.link }
                                                    onClick={ () => {
                                                        sendGAEvent('Top Mini Account', item.text);
                                                    }}
                                                    className={ `mb-1 block no-underline text-gray-700 hover:underline ${ item.classes ?? '' }` }>{ item.text }</a>
                                            }
                                        </Fragment>
                                    )
                                })
                            }

                            {
                                isLastColumn && isLoggedIn &&
                                <button
                                    type="button"
                                    className="mb-1 block no-underline text-gray-700 hover:underline"
                                    onClick={ signOut }>Sign out</button>
                            }
                        </div>
                    )
                })
            }
        </section>
    )
};

export default Links;